export const products = {
  thermal: [
    {
      id: 'testo-860t',
      name: 'testo 860t',
      image: 'https://images.pexels.com/photos/7859781/pexels-photo-7859781.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Compact thermal imager for smartphones',
      descriptionRu: 'Компактный тепловизор для смартфонов'
    },
    {
      id: 'testo-865',
      name: 'testo 865',
      image: 'https://images.pexels.com/photos/7859787/pexels-photo-7859787.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Professional thermal imaging camera',
      descriptionRu: 'Профессиональная тепловизионная камера'
    },
    {
      id: 'testo-868',
      name: 'testo 868',
      image: 'https://images.unsplash.com/photo-1767556030335-1143629d17ab?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'High-performance thermal imager',
      descriptionRu: 'Высокопроизводительный тепловизор'
    },
    {
      id: 'testo-871',
      name: 'testo 871',
      image: 'https://images.pexels.com/photos/7859781/pexels-photo-7859781.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Professional thermal imaging',
      descriptionRu: 'Профессиональная тепловизионная съемка'
    },
    {
      id: 'testo-872',
      name: 'testo 872',
      image: 'https://images.pexels.com/photos/7859787/pexels-photo-7859787.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Advanced thermal imaging solution',
      descriptionRu: 'Продвинутое решение для тепловизионной съемки'
    },
    {
      id: 'testo-883',
      name: 'testo 883',
      image: 'https://images.unsplash.com/photo-1767556030335-1143629d17ab?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'High-end thermal imaging camera',
      descriptionRu: 'Тепловизионная камера высокого класса'
    }
  ],
  gas: [
    {
      id: 'testo-330',
      name: 'testo 330',
      image: 'https://images.pexels.com/photos/6602917/pexels-photo-6602917.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Flue gas analyzer',
      descriptionRu: 'Анализатор дымовых газов'
    },
    {
      id: 'testo-320',
      name: 'testo 320',
      image: 'https://images.pexels.com/photos/33712451/pexels-photo-33712451.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Basic flue gas analyzer',
      descriptionRu: 'Базовый анализатор дымовых газов'
    },
    {
      id: 'testo-300',
      name: 'testo 300',
      image: 'https://images.pexels.com/photos/6602917/pexels-photo-6602917.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Compact flue gas analyzer',
      descriptionRu: 'Компактный анализатор дымовых газов'
    },
    {
      id: 'testo-310',
      name: 'testo 310',
      image: 'https://images.pexels.com/photos/33712451/pexels-photo-33712451.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Entry-level gas analyzer',
      descriptionRu: 'Газоанализатор начального уровня'
    },
    {
      id: 'testo-316',
      name: 'testo 316',
      image: 'https://images.pexels.com/photos/6602917/pexels-photo-6602917.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Gas leak detector',
      descriptionRu: 'Детектор утечки газа'
    },
    {
      id: 'testo-511',
      name: 'testo 511',
      image: 'https://images.unsplash.com/photo-1758295745926-88faff7ec2f2?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'Pocket absolute pressure meter',
      descriptionRu: 'Карманный измеритель абсолютного давления'
    }
  ],
  climate: [
    {
      id: 'testo-605-h1',
      name: 'testo 605-H1',
      image: 'https://images.pexels.com/photos/9182633/pexels-photo-9182633.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Thermo-hygrometer',
      descriptionRu: 'Термогигрометр'
    },
    {
      id: 'testo-605-h2',
      name: 'testo 605-H2',
      image: 'https://images.pexels.com/photos/9182633/pexels-photo-9182633.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Advanced thermo-hygrometer',
      descriptionRu: 'Усовершенствованный термогигрометр'
    },
    {
      id: 'testo-606-1',
      name: 'testo 606-1',
      image: 'https://images.pexels.com/photos/6602917/pexels-photo-6602917.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Pocket moisture meter',
      descriptionRu: 'Карманный влагомер'
    },
    {
      id: 'testo-606-2',
      name: 'testo 606-2',
      image: 'https://images.pexels.com/photos/33712451/pexels-photo-33712451.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Advanced moisture meter',
      descriptionRu: 'Усовершенствованный влагомер'
    },
    {
      id: 'testo-440',
      name: 'testo 440',
      image: 'https://images.pexels.com/photos/9182633/pexels-photo-9182633.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Multifunctional climate meter',
      descriptionRu: 'Многофункциональный климатический прибор'
    },
    {
      id: 'testo-480',
      name: 'testo 480',
      image: 'https://images.pexels.com/photos/6602917/pexels-photo-6602917.jpeg?auto=compress&cs=tinysrgb&w=800',
      price: 'Contact',
      descriptionEn: 'Professional climate measurement',
      descriptionRu: 'Профессиональное измерение климата'
    }
  ],
  electrical: [
    {
      id: 'testo-755-2',
      name: 'testo 755-2',
      image: 'https://images.unsplash.com/photo-1758295745926-88faff7ec2f2?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'Current-voltage tester',
      descriptionRu: 'Тестер тока и напряжения'
    },
    {
      id: 'testo-760-1',
      name: 'testo 760-1',
      image: 'https://images.unsplash.com/photo-1758295745926-88faff7ec2f2?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'Digital multimeter',
      descriptionRu: 'Цифровой мультиметр'
    },
    {
      id: 'testo-760-3',
      name: 'testo 760-3',
      image: 'https://images.unsplash.com/photo-1758295745926-88faff7ec2f2?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'TRMS multimeter',
      descriptionRu: 'Мультиметр TRMS'
    },
    {
      id: 'testo-770-3',
      name: 'testo 770-3',
      image: 'https://images.unsplash.com/photo-1759571796674-295d4e332813?w=800&q=80',
      price: 'Contact',
      descriptionEn: 'Clamp meter premium kit',
      descriptionRu: 'Клещи электроизмерительные, премиум-комплект'
    }
  ]
};

export const applications = [
  {
    id: 'heating',
    titleEn: 'Heating Technology',
    titleRu: 'Отопление',
    descriptionEn: 'Professional measurement solutions for heating systems',
    descriptionRu: 'Профессиональные измерительные решения для систем отопления',
    image: 'https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 'food',
    titleEn: 'Food Sector',
    titleRu: 'Пищевой сектор',
    descriptionEn: 'Ensuring food safety with precise temperature monitoring',
    descriptionRu: 'Обеспечение безопасности пищевых продуктов с точным контролем температуры',
    image: 'https://images.pexels.com/photos/9182633/pexels-photo-9182633.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 'pharma',
    titleEn: 'Pharmaceuticals & Healthcare',
    titleRu: 'Фармацевтика и здравоохранение',
    descriptionEn: 'Regulatory compliance and quality assurance solutions',
    descriptionRu: 'Решения для соответствия нормам и контроля качества',
    image: 'https://images.unsplash.com/photo-1748349221526-33b51820b21e?w=800&q=80'
  },
  {
    id: 'industry',
    titleEn: 'Industry',
    titleRu: 'Промышленность',
    descriptionEn: 'Industrial measurement and monitoring solutions',
    descriptionRu: 'Промышленные измерительные и мониторинговые решения',
    image: 'https://images.unsplash.com/photo-1748002645678-7f9c04263315?w=800&q=80'
  }
];